import { range } from 'lodash';

/* eslint-disable max-len */
export function requiredRule(message = 'Dieses Feld muss gefüllt sein'): (value: any) => boolean|string {
  return (value) => ((typeof value !== 'string' && !!value) || (typeof value === 'string' && !!value.trim()) || value === 0) || message;
}

export function requiredCheckboxRule(message = 'Diese Option muss ausgewählt sein'): (value: any) => boolean|string {
  return (value) => !!value || message;
}

export function emailRule(message = 'Die E-Mail Adresse ist nicht gültig'): (value: any) => boolean|string {
  return (value) => !value || /.+@.+\..+/.test(value) || message;
}

export function phoneRule(message = 'Die Telefonnummer ist nicht gültig'): (value: any) => boolean|string {
  return (value) => !value || /^(?:([+][0-9]{1,2})+[ .-]*)?([(]{1}[0-9]{1,6}[)])?([0-9 .-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/.test(value) || message;
}

export function passwordRule(message = 'Das Passwort muss Klein-, Großbuchstaben und Zahlen enthalten und mindestens 8 Zeichen lang sein'): (value: any) => boolean|string {
  return (value) => !value || /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/.test(value) || message;
}

export function positiveNumberRule(decimalPlaces = 0, customMessage?: string): (value: any) => boolean|string {
  let regex = new RegExp('^\\d+$');
  let message = customMessage && customMessage || 'Die Wert darf keine Nachkommastellen enthalten';

  if (decimalPlaces > 0) {
    regex = new RegExp(`^\\d+(\\.\\d{${range(1, decimalPlaces + 1).join(',')}})?$`);
    message = customMessage && customMessage || `Die Wert darf maximal ${decimalPlaces} Nachkommastellen enthalten`;
  }

  return (value) => (!value || regex.test(parseFloat(value).toString())) || message;
}

export function minNumberRule(min: number, customMessage?: string): (value: any) => boolean|string {
  const message = customMessage && customMessage || `Die Zahl darf nicht kleiner als ${min} sein`;
  return (value) => (!value || parseFloat(value) >= min) || message;
}

export function maxNumberRule(max: number, customMessage?: string): (value: any) => boolean|string {
  const message = customMessage || `Die Zahl darf nicht größer als ${max} sein`;
  return (value) => (!value || parseFloat(value) <= max) || message;
}

export function maxLengthRule(max: number, customMessage?: string): (value: any) => boolean|string {
  const message = customMessage && customMessage || `Der Wert darf aus maximal ${max} Zeichen bestehen`;
  return (value) => (!value || value.length <= max) || message;
}

export function notNullNumberRule(message = 'Die Zahl darf nicht 0 sein'): (value: any) => boolean|string {
  return (value) => (!value || parseInt(value, 10) !== 0) || message;
}

export function notEmptyArrayRule(message = 'Es muss mindestens ein Element ausgewählt sein'): (value: any) => boolean|string {
  return (value) => (!value || Array.isArray(value) && value.length > 0) || message;
}

export function activeOptionsBetweenRule(min: number, max: number, message = 'Es ist nicht die richtige Anzahl an Elementen ausgewählt'): (value: any) => boolean|string {
  return (value) => (!value || Array.isArray(value) && value.length >= min && value.length <= max) || message;
}

export function passwordsIdenticalRule(form: { fields: { password?: string } }, message = 'Die Passwörter müssen identisch sein'): (value: any) => boolean|string {
  return (value) => (!value || value === form.fields.password) || message;
}

export function csvCompliantRule(message = 'Darf keines der folgenden Zeichen enthalten: \' " , ;'): (value: any) => boolean|string {
  return (value) => (!value || !value.match('[,;"\']')) || message;
}
/* eslint-enable max-len */
